import styled from "styled-components";
import { Spinner } from "@xfrontend/xui-react-plus";

// Project-standard page loading indicator: the same xui Spinner used by the Dashboard / Policies,
// centered in the page area. Use wherever a route would otherwise render a blank screen while
// data (e.g. the org / roles bootstrap) is still resolving.
const Wrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 60vh;
`;

const PageLoading = (): JSX.Element => (
  <Wrap>
    <Spinner animation="border" variant="primary" />
  </Wrap>
);

export default PageLoading;
